import { defaultDonationCampaigns } from 'types';
import { ClientOnly } from '../../components/general/force-client';
import { A } from '../../components/general/link';
import { Meta } from '../../components/meta/meta';
import { DonateForm } from '../donate';

export default function LudwigEamighMarchMadness() {
  return (
    <>
      <Meta
        title="Cocktails for a Cause"
        description="Danny & Lauren Evans Cocktails for a Cause to benifit Beds for Kids"
        blueTopArch
      />

      <main className="mt-8 lg:py-8">
        {/* <div className="mx-auto max-w-96 mt-8 items-center">
          <LogoMainLong className="mx-auto" />
        </div> */}
        <section className="px-4 text-blue-500 lg:px-0">
          <h1 className="mx-auto mt-4 max-w-3xl text-center font-operetta text-3xl md:text-5xl">
            Cocktails for a Cause
            <br />
            to benefit Beds for Kids
          </h1>
          <p className="mx-auto mb-4 mt-1 max-w-3xl px-4 text-center font-avenir text-xl leading-6 md:text-2xl md:leading-7">
            Hosted by <br className="md:hidden" />
            Danny & Lauren Evans
          </p>
          <p className="mx-auto max-w-3xl px-4 text-center font-avenir text-xl leading-6">
            The mission of Beds for Kids is to provide beds and essential furniture to children and their families in
            need. The Charlotte based furniture bank is on pace to surpass the 1,002 families they served in 2023.
          </p>
        </section>
        <section className="mt-8 flex flex-col gap-4 px-4 text-blue-500 lg:px-0">
          <p className="mx-auto max-w-3xl px-4 text-center font-avenir text-xl font-semibold leading-6">
            6:00 PM - 10:00 PM
            <br />
            Thursday, May 16th, 2024
          </p>
          <p className="mx-auto max-w-3xl px-4 text-center font-avenir text-xl font-semibold leading-6">
            <A
              href="https://maps.app.goo.gl/o9BuzSoodvznKYPZ9"
              external
              className="underline hover:underline lg:no-underline">
              The Casey by Beau Monde <br />
              1801 N Tryon St, Charlotte, NC 28206
            </A>
          </p>
        </section>
        <section className="mt-16">
          <h2 className="mx-auto my-4 max-w-3xl text-center font-operetta text-4xl text-blue-500 md:text-5xl">
            donate now!
          </h2>
          <ClientOnly>
            <DonateForm fixedCampaign={defaultDonationCampaigns.evansCocktailsForACause2024} noRecurring />
          </ClientOnly>
        </section>
      </main>
    </>
  );
}
